import {RequestState} from "modules/enums";
import type {TStore} from "modules/types/store";
import {createSelector} from "reselect";

export const getLeadersStore = (store: TStore) => store.leaders;

export const getLeadersCollection = createSelector([getLeadersStore], (leadersStore) => {
	return leadersStore.leaders;
});

export const isLoadedLeadersPicks = createSelector(
	[getLeadersStore],
	(streak) => streak.requestState === RequestState.RECEIVED
);
